import React from 'react';
import { AlertTriangle, X, Trash2 } from 'lucide-react';

interface FeedbackDeleteConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const FeedbackDeleteConfirmModal: React.FC<FeedbackDeleteConfirmModalProps> = ({ onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4">
      <div className="bg-slate-900/95 border border-red-500/30 rounded-xl shadow-2xl w-full max-w-md p-6">
        <div className="flex items-start space-x-4 mb-4">
          <div className="flex-shrink-0 p-2 rounded-lg bg-red-500/20">
            <AlertTriangle className="w-6 h-6 text-red-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-1 text-red-400">Confirm Deletion</h3>
            <p className="text-sm text-gray-300">Are you sure you want to delete your feedback? This action cannot be undone.</p>
          </div>
          <button onClick={onCancel} className="text-gray-400 hover:text-white transition-colors flex-shrink-0">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex items-center justify-end space-x-3">
          <button onClick={onCancel} className="px-4 py-2 text-sm text-gray-400 hover:text-white transition-colors">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white text-sm rounded-lg font-medium hover:from-red-600 hover:to-red-700 transition-all flex items-center space-x-2"
          >
            <Trash2 className="w-4 h-4" />
            <span>Delete</span>
          </button>
        </div>
      </div>
    </div>
  );
};
